import { Text } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.semiBold,
      textAlign: 'center',
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      backgroundColor: 'transparent',
      color: theme.colorLabelingTextPrincipalDefault,
      fontSize: theme.fontSizeThreepulse,
      height: theme.sizingExtrasmall,
      flexShrink: 1,
      flexWrap: 'wrap',
      overflow: 'hidden',
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
    },
    variants: {
      variant: {
        average: { color: 'rgba(85, 53, 12, 1)' },
        strong: { color: 'rgba(24, 73, 33, 1)' },
        weak: { color: 'rgba(100, 32, 73, 1)' },
        'on-sale': {
          color: theme.colorLabelingTextOnsaleDefault,
        },
        principal: {
          color: theme.colorLabelingTextPrincipalDefault,
        },
        secondary: {
          color: theme.colorLabelingTextSecondaryDefault,
        },
        'clube-raia': {
          color: theme.colorLabelingTextClubeDefault,
        },
        'clube-drogasil': {
          color: theme.colorLabelingTextClubeDefault,
        },
        assinatura: {
          color: theme.colorLabelingTextAssinaturaDefault,
        },
        generico: {
          color: theme.colorLabelingTextGenericoDefault,
        },
        'medicamento-de-geladeira': {
          color: theme.colorLabelingTextRefrigerateDefault,
        },
        'receita-obrigatoria': {
          color: theme.colorLabelingTextPrescriptionDefault,
        },
        referencia: {
          color: theme.colorLabelingTextReferenciaDefault,
        },
        similar: {
          color: theme.colorLabelingTextSimilarDefault,
        },
        'ganhe-stix': {
          color: theme.colorLabelingTextStixDefault,
        },
        'trocar-stix': {
          color: theme.colorLabelingTextStixDefault,
        },
        patrocinado: {
          color: theme.colorTextNeutralPlaceholder,
        },
      },
    },
  }
})
